import React from 'react';
import textLogo from './text-logo.png';
import menuIcon from './menu.png';
import styles from './Header.module.scss';

const MobileHeader = props => {
  return (
    <header className={styles.mobileHeader}>
      <img
        className={styles.textLogo}
        src={textLogo}
        alt='site-logo'
      />
      <img
        className={styles.menuIcon}
        src={menuIcon}
        alt='menu-icon'
        onClick={() => props.handleClick()}
      />
    </header>
  );
}

export default MobileHeader;